import formatDiscount from '../../lib/utils/formatDiscount';

export const gasbackLandingPageSteps = [
  {
    content: 'Find relevant GasBack offers at popular retailers on the savings tab of our top-rated app.',
    header: 'Download GasBuddy',
    stepText: '1',
  },
  {
    content: 'Earn GasBack on each qualified purchase. Earn up to 10% of your purchase or a lump sum (think $10 to spend on gas)',
    header: 'Shop, Dine, Park, Earn',
    stepText: '2',
  },
  {
    content: `Automatically redeem your GasBack at the pump when you pay with your Pay with GasBuddy card. In addition to your GasBack, this free card saves you up to ${formatDiscount(25)} per gallon.`,
    header: 'Save Big At The Pump',
    stepText: '3',
  },
];
